import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import useDialer from "./hooks/use-dialer";
import DialerNumPad from "./components/dialer-num-pad";
import DialerNumbersDropdown from "./components/dialer-numbers-dropdown";
import DialerInputField from "./components/dialer-input-field";
import stopRecord from "../../../images/recording_off.svg";
import record from "../../../images/recording_on.svg";

const Dialer = ({ contact, name, phones }) => {
  //note that this does not initiate the recording itself, its just on UI end currently. Needs to be integrated with the BE.
  const [recordStatus, setRecordStatus] = useState(false);
  const setRecording = () => {
    setRecordStatus(!recordStatus);
  };

  const {
    phoneRef,
    extensionRef,
    phoneNumber,
    extension,
    onPhoneFocus,
    onExtFocus,
    handleInput,
    handleDropdownInput,
    CallerButton,
    activeCall,
  } = useDialer(contact.id);

  useEffect(() => {
    if (!activeCall && recordStatus) setRecordStatus(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeCall]);

  return (
    <div className="dialer">
      <img
        src={recordStatus ? record : stopRecord}
        alt="record"
        onClick={activeCall ? setRecording : () => {}}
        style={{ cursor: activeCall ? "pointer" : "default" }}
      />
      <div className="dialer--contact-info">
        <DialerNumbersDropdown
          name={name}
          phones={phones}
          handleNumberChange={handleDropdownInput}
          value={phoneNumber}
        />
        <DialerInputField
          phoneRef={phoneRef}
          extensionRef={extensionRef}
          phoneNumber={phoneNumber}
          extension={extension}
          onPhoneFocus={onPhoneFocus}
          onExtFocus={onExtFocus}
          handleInput={handleInput}
        />
        <CallerButton />
      </div>
      <DialerNumPad handleNumPadPress={handleInput} />
    </div>
  );
};

/**
 * PropTypes for the Dialer component:
 * - phones: An array of phone numbers.
 * - name: The name of the contact.
 * - contact: The contact object.
 */
Dialer.propTypes = {
  phones: PropTypes.array,
  name: PropTypes.string,
  contact: PropTypes.object,
};

export default Dialer;
